import { useAsyncEffect } from "@react-hook/async"

export const DynamicIcon = ({ name, ...props }) => {
  const { value: Component } = useAsyncEffect(async () => {
    try {
      const module = await import(`components/Icon/${name}.js`)
      return module[name]
    } catch (err) {
      console.error(`Icon ${name} cannot be found.`)
      console.error(err)

      return null
    }
  }, [name])

  if (Component) {
    return <Component {...props} />
  }

  return null
}
